import { render, staticRenderFns } from "./BlogPageBalloon.vue?vue&type=template&id=85d23208&scoped=true"
import script from "./BlogPageBalloon.vue?vue&type=script&lang=ts"
export * from "./BlogPageBalloon.vue?vue&type=script&lang=ts"
import style0 from "./BlogPageBalloon.vue?vue&type=style&index=0&id=85d23208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d23208",
  null
  
)

export default component.exports